import React from 'react';
export function EditorSpellcheckIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.775 7l.228 2.055.994-.11-.39-3.506a1.617 1.617 0 00-3.214 0l-.39 3.506.994.11L4.225 7h1.55zM5 5a.617.617 0 00-.614.55l-.05.45h1.328l-.05-.45A.617.617 0 005 5zm5.5-1H8v5h2.5a1.5 1.5 0 001.118-2.5A1.5 1.5 0 0010.5 4zm0 1H9v1h1.5a.5.5 0 000-1zM9 7v1h1.5a.5.5 0 000-1H9z"
  }), React.createElement("path", {
    d: "M14.5 5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2v1h-2A1.5 1.5 0 0113 7.5v-2A1.5 1.5 0 0114.5 4h2v1h-2zm-3 14.914L21.707 9.707l-1.414-1.414-8.793 8.793-3.793-3.793-1.414 1.414 5.207 5.207z"
  }));
}